import { render, staticRenderFns } from "./TemplateDetail.vue?vue&type=template&id=3bde5c12&scoped=true&"
import script from "./TemplateDetail.vue?vue&type=script&lang=js&"
export * from "./TemplateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bde5c12",
  null
  
)

export default component.exports